// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { PortalHeader } from "src/modules/header-portal/jsx/component.jsx";
import { NavigationPanel } from "src/modules/nav-panel/jsx/component.jsx";
import { PortalPage } from "src/modules/pages/jsx/_switcher.jsx";
import { Poll } from "src/modules/poll/jsx/component.jsx";
import { Modal } from "src/modules/modal/jsx/modal.jsx";
import { StaffTools } from "src/modules/simulation-panel/jsx/staff-tools.jsx";
import { gu_auth } from "src/lib/authentication.js";


// Stateful components

export class Portal extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {};
    }


    //
    // Functions
    //

    getMainClass(current_page) {
        var main_class = 'main ';

        if(current_page === '') {
            current_page = 'home';
        }

        current_page = current_page.replace(/-/g, '_');

        return main_class += current_page;
    }

    checkToolsAccess() {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_profile = portal_context['user_personalisation'];
        var show_tools = false;

        if(user_profile) {
            // Check which level of access the user has
            var can_simulate = gu_auth.fn.canSimulate(user_profile);
            var can_modify_attributes = gu_auth.fn.canModifyAttributes(user_profile);
            var can_access_staff_mode = gu_auth.fn.canAccessStaffMode(user_profile['attributes']);

            // Show tools panel if you meet any of these criteria
            if(can_simulate || can_modify_attributes || can_access_staff_mode) {
                show_tools = true;
            }
        }

        return show_tools;
    }


    //
    // Render
    //

    render() {
        var this_component = this;
        var portal_context = this_component['context'];
        var is_loading = portal_context['is_loading'];
        var is_refreshing = portal_context['is_refreshing'];
        var page_error = portal_context['page_error'];
        var current_page = portal_context['current_page'];
        var show_modal = portal_context['show_modal'];
        var tools_access = this_component.checkToolsAccess();
        var loading_image = 'https://squiz.my.griffith.edu.au/__data/assets/image/0022/901930/loader.gif';
        var user_personalisation = portal_context['user_personalisation'];
        var user_attributes = '';
        if (user_personalisation !== null) {
            if (typeof(user_personalisation['attributes']) !== 'undefined') {
                user_attributes = JSON.stringify(user_personalisation['attributes']);
            }
        }

        var main_class = this_component.getMainClass(current_page);

        // Set up loading screen
        var loading_content = 
            <div className="loading__wrapper">
                <img src={loading_image} alt="Loading..." />
            </div>;
        
        return (
            <>
                <PortalHeader />
                {is_loading ? (
                    <main className={main_class} role="main">
                        {loading_content}
                    </main>
                ) : (
                    <>
                        {page_error.length > 0 ? (
                            <main className={main_class} role="main">
                                <div className="loading__wrapper" dangerouslySetInnerHTML={{__html: page_error}}>
                                </div>
                            </main>
                        ) : (
                            <>    
                                {is_refreshing ? (
                                    <main className={main_class} role="main">
                                        {loading_content}
                                    </main>
                                ) : (
                                    <>
                                        <main className={main_class} role="main">
                                            <NavigationPanel />
                                            <PortalPage key={user_attributes} page={current_page} />
                                        </main>
                                        <Poll />
                                        {show_modal &&
                                        <Modal />
                                        }
                                    </>
                                )}
                                
                                {tools_access &&
                                <StaffTools />
                                }
                            </>
                        )}
                    </>
                )}
            </>
        );
    }

};

Portal.contextType = PortalContext;
